<template>
  <v-data-table
    :items="ingredients"
    :headers="headers"
    :items-per-page="ingredients.length + 1"
    sort-by="ordre"
    hide-default-footer
  >
    <template v-slot:item.ordre="{ item }">
      <v-text-field
        single-line
        dense
        filled
        class="no-before"
        hide-details
        :value="item.ordre"
        :disabled="item.is_deleted === true"
        style="width: 80px"
        @change="v => (item.ordre = v)"
      ></v-text-field>
    </template>
    <template v-slot:item.product="{ item }">
      <span
        @click="openIngredient(item)"
        class="subtitle-2"
        style="cursor: pointer;"
        :style="{ opacity: item.is_deleted === true ? 0.38 : 1 }"
      >
        {{
          getAllProducts.find(x => x.id === item.pk_recette_produit)
            ? getAllProducts.find(x => x.id === item.pk_recette_produit).nom
            : "Unknown"
        }}
      </span>
    </template>
    <template v-slot:item.quantite="{ item }">
      <j-decimal-input
        single-line
        dense
        filled
        class="no-before"
        v-model="item.quantite"
        :suffix="''"
        :decimal="4"
        :min="0.0001"
        hide-details
        :disabled="item.is_deleted === true"
      ></j-decimal-input>
    </template>
    <template v-slot:item.unite_mesure="{ item }">
      <v-select
        label="Unité"
        single-line
        dense
        filled
        class="no-before"
        hide-details
        :value="getIngredientUnit(item)"
        @input="v => changeUnitMesure(v, item)"
        :items="getPossibleUnitSelectionForProduct(item)"
        :disabled="item.is_deleted === true"
      ></v-select>
    </template>
    <template v-slot:item.cost="{ item }">
      {{ item.is_deleted === true ? "" : getIngredientCost(item) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <v-tooltip bottom v-if="!getIsConfigurated(item)">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="error" small>
              fa-exclamation-triangle
            </v-icon>
          </template>
          <span>Produit non configuré</span>
        </v-tooltip>
        <v-tooltip bottom v-if="getIsProductDeleted(item)">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="error" small>
              fa-exclamation-triangle
            </v-icon>
          </template>
          <span>Produit supprimé</span>
        </v-tooltip>
        <v-tooltip bottom v-if="!getIsInter(item)">
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              text
              class="mx-1"
              v-on="on"
              @click="item.is_inventory_link = !item.is_inventory_link"
              :color="item.is_inventory_link ? 'success' : ''"
            >
              <v-icon small>fa-link</v-icon>
            </v-btn>
          </template>
          <span>Lier les commandes à cet ingredient</span>
        </v-tooltip>
        <v-hover v-slot:default="{ hover }" v-show="item.is_deleted !== true">
          <v-btn
            small
            icon
            text
            :color="hover ? 'error' : ''"
            @click="item.is_deleted = true"
          >
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-hover>
        <v-hover v-slot:default="{ hover }" v-show="item.is_deleted === true">
          <v-btn
            small
            icon
            text
            :color="hover ? 'success' : ''"
            @click="item.is_deleted = false"
          >
            <v-icon small>fa-reply</v-icon>
          </v-btn>
        </v-hover>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import { mappers } from "@/mappers";
import { productMixin } from "@/mixins";
import round10 from "round10";
export default {
  name: "IngredientGrid",
  mixins: [productMixin],
  props: {
    ingredients: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      "getRecipes",
      "getAllProducts",
      "getOrganisationId",
      "getAllowedUnits",
      "getCustomUnits",
      "getCustomUnitsValues"
    ])
  },
  data() {
    return {
      headers: [
        { value: "ordre", text: "Ordre" },
        { value: "product", text: "Nom" },
        { value: "quantite", text: "Quantité" },
        { value: "unite_mesure", text: "Unité", width: 150 },
        { value: "cost", text: "Coût" },
        { value: "actions", text: "", sortable: false }
      ]
    };
  },
  methods: {
    getIsConfigurated(item) {
      const product = this.getAllProducts.find(
        x => x.id === item.pk_recette_produit
      );
      return product && product.data;
    },
    getIsInter(item) {
      const product = this.getAllProducts.find(
        x => x.id === item.pk_recette_produit
      );
      return product !== undefined ? product.est_intermediaire : false;
    },
    getIsProductDeleted(item) {
      const product = this.getAllProducts.find(
        x => x.id === item.pk_recette_produit
      );
      return product !== undefined ? product.is_deleted : false;
    },
    getPossibleUnitSelectionForProduct(item) {
      const product = this.getAllProducts.find(
        x => x.id === item.pk_recette_produit
      );
      try {
        return this.getProductUnitPossibilities(product);
      } catch {
        return [];
      }
    },
    getIngredientCost(item) {
      const product = this.getAllProducts.find(
        x => x.id === item.pk_recette_produit
      );
      try {
        if (product && product.data) {
          if (product.data.use_conversion_formula) {
            if (product.data.use_alternative_unit === true) {
              let alt_unit_possibilities = [];
              if (
                !mappers.isCustomUnit(
                  product.data.alternative_unite_mesure_production
                )
              ) {
                alt_unit_possibilities = this.$units()
                  .from(product.data.alternative_unite_mesure_production)
                  .possibilities()
                  .filter(x => this.getAllowedUnits.includes(x));
              } else {
                alt_unit_possibilities = this.getCustomUnits;
              }
              const is_alternative_unite_mesure = alt_unit_possibilities.includes(
                item.unite_mesure
              );
              if (is_alternative_unite_mesure) {
                if (
                  !mappers.isCustomUnit(item.unite_mesure) &&
                  !mappers.isCustomUnit(
                    product.data.alternative_unite_mesure_production
                  )
                ) {
                  const itemQtyInProductUnit = this.$units(item.quantite)
                    .from(item.unite_mesure)
                    .to(product.data.alternative_unite_mesure_production);
                  return round10.round10(
                    Number(product.data.alternative_price) *
                      itemQtyInProductUnit,
                    -4
                  );
                } else {
                  return round10.round10(
                    Number(product.data.alternative_price) * item.quantite,
                    -4
                  );
                }
              } else {
                if (
                  !mappers.isCustomUnit(item.unite_mesure) &&
                  !mappers.isCustomUnit(product.data.unite_mesure)
                ) {
                  const itemQtyInProductUnit = this.$units(item.quantite)
                    .from(item.unite_mesure)
                    .to(product.data.unite_mesure);
                  return round10.round10(
                    Number(product.data.prix) * itemQtyInProductUnit,
                    -4
                  );
                } else {
                  return round10.round10(
                    Number(product.data.prix) * item.quantite,
                    -4
                  );
                }
              }
            } else {
              if (
                !mappers.isCustomUnit(item.unite_mesure) &&
                !mappers.isCustomUnit(product.data.unite_mesure)
              ) {
                const itemQtyInProductUnit = this.$units(item.quantite)
                  .from(item.unite_mesure)
                  .to(product.data.unite_mesure);
                return round10.round10(
                  Number(product.data.prix) * itemQtyInProductUnit,
                  -4
                );
              } else {
                return round10.round10(
                  Number(product.data.prix) * item.quantite,
                  -4
                );
              }
            }
          } else {
            if (
              !mappers.isCustomUnit(item.unite_mesure) &&
              !mappers.isCustomUnit(product.data.unite_mesure_inventory)
            ) {
              const itemQtyInProductUnit = this.$units(item.quantite)
                .from(item.unite_mesure)
                .to(product.data.unite_mesure_inventory);
              return round10.round10(
                (Number(product.data.prix_inventory) /
                  product.data.quantity_inventory) *
                  itemQtyInProductUnit,
                -4
              );
            } else {
              return round10.round10(
                (Number(product.data.prix_inventory) /
                  product.data.quantity_inventory) *
                  item.quantite,
                -4
              );
            }
          }
        } else {
          return 0;
        }
      } catch {
        return 0;
      }
    },
    getIngredientUnit(item) {
      return item.unite_mesure;
    },
    changeUnitMesure(value, item) {
      const product = this.getAllProducts.find(
        x => x.id === item.pk_recette_produit
      );
      item.unite_mesure = value;
      if (product && product.data.use_alternative_unit === true) {
        let alt_unit_possibilities = [];
        if (
          !mappers.isCustomUnit(
            product.data.alternative_unite_mesure_production
          )
        ) {
          alt_unit_possibilities = this.$units()
            .from(product.data.alternative_unite_mesure_production)
            .possibilities()
            .filter(x => this.getAllowedUnits.includes(x));
        } else {
          alt_unit_possibilities = this.getCustomUnits;
        }
        item.is_alternative_unite_mesure = alt_unit_possibilities.includes(
          value
        );
      }
    },
    openIngredient(item) {
      const product = this.getAllProducts.find(
        x => x.id == item.pk_recette_produit
      );
      if (product) {
        if (product.est_intermediaire === true) {
          const recipe = this.getRecipes.find(
            x => x.fk_produit_intermediaire === product.id
          );
          if (recipe) {
            let routeData = this.$router.resolve({
              name: "RecipeEditor",
              params: { id: recipe.id }
            });
            window.open(routeData.href, "_blank");
          }
        } else {
          let routeData = this.$router.resolve({
            name: "ProductEditor",
            params: { id: product.id }
          });
          window.open(routeData.href, "_blank");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
